import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=4aeaaba2&scoped=true&"
import script from "./ProductMenu.vue?vue&type=script&lang=js&"
export * from "./ProductMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductMenu.vue?vue&type=style&index=0&id=4aeaaba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeaaba2",
  null
  
)

export default component.exports